export enum LoanProposalStatus_Enum {
  Processing = 1,
  Declined,
  ProvisionalAcceptance,
  Accepted,
  ConditionallyAccepted,
  FailedSendRules,
  MoreInfo,
  ManualProcessing
}
